"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetornoSalvarErp = void 0;
var RetornoSalvarErp = /** @class */ (function () {
    function RetornoSalvarErp() {
        this.MATERIAL = '';
    }
    return RetornoSalvarErp;
}());
exports.RetornoSalvarErp = RetornoSalvarErp;
//# sourceMappingURL=RetornoSalvarErp.js.map